
    import { defineComponent } from 'vue'
    import { AxiosResponse } from 'axios'
    import KnFabButton from '@/components/UI/KnFabButton.vue'
    import KnHint from '@/components/UI/KnHint.vue'
    import ProfileAttributesManagementDescriptor from './ProfileAttributesManagementDescriptor.json'
    import ProfileAttributesDetail from './ProfileAttributesDetail.vue'
    import AttributesListBox from './AttributesListBox.vue'
    import { iAttribute } from './ProfileAttributesManagement'

    export default defineComponent({
        name: 'profile-attributes',
        components: {
            AttributesListBox,
            KnFabButton,
            KnHint,
            ProfileAttributesDetail
        },
        data() {
            return {
                apiUrl: process.env.VUE_APP_RESTFUL_SERVICES_PATH + '2.0/',
                attributes: [] as iAttribute[],
                attribute: {} as iAttribute,
                tempAttribute: {} as iAttribute,
                profileAttributesManagementDescriptor: ProfileAttributesManagementDescriptor,
                columns: ProfileAttributesManagementDescriptor.columns,
                loading: false as Boolean,
                hideForm: true as Boolean,
                dirty: false as Boolean
            }
        },
        async created() {
            await this.loadAllAttributes()
        },
        methods: {
            async loadAllAttributes() {
                this.loading = true
                this.hideForm = true
                this.dirty = false
                await this.$http
                    .get(this.apiUrl + 'attributes')
                    .then((response: AxiosResponse<any>) => {
                        this.attributes = response.data
                    })
                    .finally(() => (this.loading = false))
            },
            onAttributeSelect(attribute?: iAttribute) {
                if (this.dirty) {
                    this.$confirm.require({
                        message: this.$t('common.toast.unsavedChangesMessage'),
                        header: this.$t('common.toast.unsavedChangesHeader'),
                        icon: 'pi pi-exclamation-triangle',
                        accept: () => {
                            this.dirty = false
                            if (attribute) this.prepareFormData(attribute)
                            else this.hideForm = true
                        }
                    })
                } else {
                    if (attribute) this.prepareFormData(attribute)
                    else this.hideForm = true
                }
            },
            prepareFormData(attribute: iAttribute) {
                if (this.hideForm) {
                    this.hideForm = false
                }
                this.attribute = { ...attribute }
            },
            onAttributeDelete(id: number) {
                this.deleteAttribute(id)
            },
            showForm() {
                this.hideForm = false
                this.attribute = {
                    attributeId: null,
                    attributeName: '',
                    attributeDescription: '',
                    allowUser: null,
                    multivalue: null,
                    syntax: null,
                    lovId: null,
                    value: {}
                }
            },
            closeForm() {
                // this.hideForm = true
                this.onAttributeSelect()
            },
            async deleteAttribute(id: number) {
                this.$confirm.require({
                    message: this.$t('common.toast.deleteMessage'),
                    header: this.$t('common.toast.deleteConfirmTitle'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: async () => {
                        this.loading = true
                        this.axios
                            .delete(this.apiUrl + 'attributes/' + id, { headers: { 'X-Disable-Errors': 'true' } })
                            .then((response: AxiosResponse<any>) => {
                                if (response.data.errors) {
                                    this.$store.commit('setError', {
                                        title: this.$t('managers.profileAttributesManagement.info.deleteTitle'),
                                        msg: this.$t('managers.profileAttributesManagement.error.profileAttributeDeletion')
                                    })
                                } else {
                                    this.$store.commit('setInfo', {
                                        title: this.$t('managers.profileAttributesManagement.info.deleteTitle'),
                                        msg: this.$t('managers.profileAttributesManagement.info.deleteMessage')
                                    })
                                    this.loadAllAttributes()
                                }
                            })
                            .catch(() => {
                                this.$store.commit('setError', {
                                    title: this.$t('managers.profileAttributesManagement.info.deleteTitle'),
                                    msg: this.$t('managers.profileAttributesManagement.error.profileAttributeDeletion')
                                })
                            })
                            .catch((error) => {
                                this.$store.commit('setError', {
                                    title: this.$t('managers.profileAttributesManagement.info.deleteTitle'),
                                    msg: error.message
                                })
                            })
                            .finally(() => {
                                this.loading = false
                            })
                    }
                })
            }
        }
    })
